import { useEffect } from 'react';

import { ClickTarget, click } from '@tracking';

import type { UseAnalyticsWrapperProps } from './interfaces';

// Symbol to mark events as already tracked to prevent bubbling duplicates
const ANALYTICS_TRACKED = Symbol('analyticsTracked');

const useAnalyticsWrapper = ({ trackEvent, containerRef }: UseAnalyticsWrapperProps) => {
  useEffect(() => {
    let eventTracker;
    const container = containerRef.current;

    if (container) {
      eventTracker = (event) => {
        if (event[ANALYTICS_TRACKED]) return;

        const target = event.target as HTMLElement;
        const anchorLink = target.closest('a');
        const button = target.closest('button');
        const text = target.innerText;

        if (anchorLink || button) {
          event[ANALYTICS_TRACKED] = true;
          trackEvent(
            click({
              clickTarget: anchorLink ? ClickTarget.AnchorLink : ClickTarget.Button,
              clickText: text,
            })
          );
        }
      };
      container.addEventListener('click', eventTracker, { passive: true });
    }

    return () => {
      if (eventTracker && container) {
        container.removeEventListener('click', eventTracker, {
          passive: true,
        } as EventListenerOptions);
      }
    };
  }, [containerRef, trackEvent]);
};

export default useAnalyticsWrapper;
